import type { InjectionKey } from 'vue';

import i18n from '@/i18n';
import { MissionCommand } from '@/types/mission';

import {
	type DropdownGeneratorAction,
	DropdownGeneratorActionType,
	DropdownItemColors,
} from '@/dsComponents/Dropdown/types';

export const workerMissionActionsSymbol: InjectionKey<
	(commandName: MissionCommand) => void
> = Symbol('WorkerMissionAction');

export const agencyMissionActionsList = (): (DropdownGeneratorAction & {
	commandName?: MissionCommand;
})[] => [
	{
		type: DropdownGeneratorActionType.title,
		title: {
			icon: 'building-estate',
			label: i18n.global.t('global.agency'),
		},
	},
	{
		commandName: MissionCommand.propose,
		type: DropdownGeneratorActionType.item,
		item: {
			labelColor: DropdownItemColors.lightGrey,
			label: i18n.global.t('mission.availableCommands.propose.text'),
		},
	},
	{
		commandName: MissionCommand.repropose,
		type: DropdownGeneratorActionType.item,
		item: {
			labelColor: DropdownItemColors.lightGrey,
			label: i18n.global.t('mission.availableCommands.repropose.text'),
		},
	},
	{
		commandName: MissionCommand.workerPropose,
		type: DropdownGeneratorActionType.item,
		item: {
			labelColor: DropdownItemColors.lightGrey,
			label: i18n.global.t('mission.availableCommands.workerPropose.text'),
		},
	},
	{
		commandName: MissionCommand.workerConfirm,
		type: DropdownGeneratorActionType.item,
		item: {
			labelColor: DropdownItemColors.lightGrey,
			label: i18n.global.t('global.actions.confirm'),
		},
	},
	{
		commandName: MissionCommand.verifyConfirmWorker,
		type: DropdownGeneratorActionType.item,
		item: {
			labelColor: DropdownItemColors.lightGrey,
			label: i18n.global.t('global.actions.confirm'),
		},
	},
	{
		commandName: MissionCommand.notConfirm,
		type: DropdownGeneratorActionType.item,
		item: {
			labelColor: DropdownItemColors.red,
			label: i18n.global.t('mission.availableCommands.notConfirm.text'),
		},
	},
	{
		commandName: MissionCommand.workerReproposed,
		type: DropdownGeneratorActionType.item,
		item: {
			labelColor: DropdownItemColors.lightGrey,
			label: i18n.global.t('mission.availableCommands.workerReproposed.text'),
		},
	},
	{
		commandName: MissionCommand.workerReproposedBySMS,
		type: DropdownGeneratorActionType.item,
		item: {
			labelColor: DropdownItemColors.lightGrey,
			label: i18n.global.t(
				'mission.availableCommands.workerReproposedBySMS.text'
			),
		},
	},
	{
		commandName: MissionCommand.workerAgencyReject,
		type: DropdownGeneratorActionType.item,
		item: {
			labelColor: DropdownItemColors.lightGrey,
			label: i18n.global.t('global.actions.cancel'),
		},
	},
	{
		commandName: MissionCommand.removeWorker,
		type: DropdownGeneratorActionType.item,
		item: {
			labelColor: DropdownItemColors.red,
			label: i18n.global.t('mission.availableCommands.removeWorker.text'),
		},
	},
];

export const workerMissionActionsList = (): (DropdownGeneratorAction & {
	commandName?: MissionCommand;
})[] => [
	{
		type: DropdownGeneratorActionType.title,
		title: {
			icon: 'user',
			label: i18n.global.t('global.worker'),
		},
	},
	{
		commandName: MissionCommand.workerAccept,
		type: DropdownGeneratorActionType.item,
		item: {
			labelColor: DropdownItemColors.lightGrey,
			label: i18n.global.t('mission.availableCommands.workerAccept.text'),
		},
	},
	{
		commandName: MissionCommand.workerDecline,
		type: DropdownGeneratorActionType.item,
		item: {
			labelColor: DropdownItemColors.red,
			label: i18n.global.t('mission.availableCommands.workerDecline.text'),
		},
	},
	{
		commandName: MissionCommand.workerAbort,
		type: DropdownGeneratorActionType.item,
		item: {
			labelColor: DropdownItemColors.red,
			label: i18n.global.t('mission.availableCommands.workerAbort.text'),
		},
	},
];
